import { render } from "./YearEndLeaveReport.vue?vue&type=template&id=0a39e02c&scoped=true"
import script from "./YearEndLeaveReport.vue?vue&type=script&lang=js"
export * from "./YearEndLeaveReport.vue?vue&type=script&lang=js"

import "./YearEndLeaveReport.vue?vue&type=style&index=0&id=0a39e02c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a39e02c"]])

export default __exports__